interface Props {
  isRTL: boolean;
  onClick(): void;
}
const SvgCrumbBack: React.FC<Props> = ({ isRTL, onClick }) => {
  return (
    <svg
      style={{
        cursor: "pointer",
        transform: isRTL ? "scaleX(-1)" : "",
        margin: "0 0 0 16px",
      }}
      onClick={onClick}
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="icon">
        <path
          id="Vector"
          d="M11.9883 2.39414C11.8324 2.39879 11.6845 2.46394 11.5758 2.57578L5.57578 8.57578C5.4633 8.68831 5.40012 8.8409 5.40012 9C5.40012 9.15911 5.4633 9.3117 5.57578 9.42422L11.5758 15.4242C11.6311 15.4818 11.6973 15.5278 11.7706 15.5595C11.8438 15.5911 11.9227 15.6079 12.0025 15.6087C12.0824 15.6095 12.1615 15.5944 12.2354 15.5642C12.3094 15.534 12.3765 15.4894 12.4329 15.4329C12.4894 15.3765 12.534 15.3094 12.5642 15.2354C12.5944 15.1615 12.6095 15.0824 12.6087 15.0025C12.6079 14.9227 12.5911 14.8438 12.5594 14.7706C12.5278 14.6973 12.4818 14.6311 12.4242 14.5758L6.84844 9L12.4242 3.42422C12.5109 3.33994 12.5701 3.23144 12.5941 3.11293C12.6181 2.99442 12.6057 2.87143 12.5586 2.76007C12.5115 2.64872 12.4318 2.5542 12.33 2.48891C12.2283 2.42361 12.1091 2.39058 11.9883 2.39414Z"
          fill="#5B5B5B"
        />
      </g>
    </svg>
  );
};

export default SvgCrumbBack;
